// HASTA CUÁNDO ENTRA Y CUÁNTO LE QUEDA, DICHO IGUAL EN TODAS LAS PANTALLAS (12-10-2026).
//
// Eran tres cuentas para el mismo fin de plan: el diálogo de "No quiero renovar" decía
// "8 de enero", Mi perfil "88 días" y la renovación "90 días, hasta el domingo 10 de enero".
// La cuenta buena es una sola y la hace el servidor (`core/renovacion.estado_del_ciclo`): el
// último día con acceso es el DOMINGO de la semana en que se acaba lo pagado, y los días se
// cuentan hasta ese domingo con el día de España. Aquí solo se escribe, con las mismas
// palabras para las tres pantallas. Lo que llega es `{ ultimo_dia, dias_restantes }`: de
// `ciclo` en la renovación y de `profile.renovacion` en Mi perfil.
import { pintarDia } from './horaEspana';

// "domingo, 10 de enero". Vacío si no hay día.
export const diaDelFin = (ultimoDia) =>
    pintarDia(ultimoDia, { weekday: 'long', day: 'numeric', month: 'long' });

// "Te quedan 90 días · hasta el domingo, 10 de enero". Null si no se sabe o ya pasó.
export const loQueQueda = (fin) => {
    const dias = fin?.dias_restantes;
    if (dias == null || dias < 0) return null;
    const cuanto = dias === 0 ? 'Tu acceso acaba hoy'
        : `Te queda${dias === 1 ? '' : 'n'} ${dias} día${dias === 1 ? '' : 's'}`;
    const hasta = dias > 0 && fin?.ultimo_dia ? diaDelFin(fin.ultimo_dia) : '';
    return hasta ? `${cuanto} · hasta el ${hasta}` : cuanto;
};

// " (el domingo, 10 de enero)" para meterlo en una frase; vacío si no se sabe.
export const hastaCuandoEntra = (fin) => {
    const hasta = fin?.ultimo_dia && (fin?.dias_restantes == null || fin.dias_restantes >= 0)
        ? diaDelFin(fin.ultimo_dia) : '';
    return hasta ? `el ${hasta}` : '';
};
